<template>
  <div class="main-container myorder deposit mt30">
    <!--    <code>    {{ orders }}</code>-->
    <div class="container-fluid device-max-area">
      <div class="row">
        <div class="col-md-12">
<!--          <div class="myorders promotion_msg mt30" >-->
<!--            <div class="status-msg"  src="@/assets/images/info-blue.png" width="18px">&nbsp;-->
<!--              <b>Refer Your Family and Friends & Earn Deposit Money as Gift!!</b>-->
<!--              <a href="" class="btn btn-sm pull-right btn-more">Learn More</a>-->
<!--            </div>-->
<!--          </div>-->
          <div>
            <div class="income_summary affiliate animated slideInUp">
              <img src="@/assets/images/baloon.png" class="leftbg" alt="alt">
              <br/>

              <p class="deposit-title"><b>How <br>to earn <br> Deposit Money</b>
              </p>
              <div v-if="globalLanguage=='EN'" v-html="message_en"></div>
              <div v-else v-html="message_bn"></div>
              <div class="deposit_form">
                <div class="customer-details mt30">
                  <div class="row">
                    <div class="col-md-12 bill-info text-left mt30">
                      <div class="myorders" style="color: #e91e63;" v-if="response_message">
                        <div class="status-msg" >
                          {{response_message}}
                        </div>
                      </div>
                      <div v-if="user_id">
                      <div>
                        <h3 class="c-title text-left" v-if="globalLanguage=='EN'">Enter  Referer Phone Number</h3>
                        <h3 class="c-title text-left" v-else>রেফারার ফোন নম্বর লিখুন </h3>
                      </div>
                      <div>
                        <div class="form-group">
                          <div class="realtive-area">
                            <input type="text" v-model="phone" placeholder="Referer Phone Number"
                                   class="form-control checkephone"></div>
                          <div id="OtpSuccess" class="smslabel phoneStatus"></div>
                        </div>
                        <div class="mb10">
                          <button class="btn btn-base orderCompleteBtn pull-right" @click="addRefererPhone">Submit</button>
                        </div>
                      </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="user_id">
          <div class="income_summary affiliate noshadow animated slideInUp">
            <div class="panel panel-default myorders">
              <div class="panel-body">
                <div class="order-items">
                  <div class="row" v-if="customers" >
                    <div class="col-lg-12 table-responsive">
                      <div class="table-responsive no-border">
                        <table class="table  table-responsive  table-striped checkout-table">
                          <thead>
                          <tr>
                            <th>Phone Number</th>
                            <th>Gift</th>
                            <th>Engage Date</th>
                            <th>Comment</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="text-left" v-for="(customer, index) in customers">
                            <td><i class="fa fa-call"></i> {{customer.referer_phone}}</td>
                            <td>
                              <b class="base-color" v-if="customer.gift_amount>0">&#2547;{{customer.gift_amount}}</b>
                              <b class="orange-color" v-else>&#2547;0</b>
                            </td>
                            <td>{{customer.created_at | formatDate}}</td>
                            <td>{{customer.comment}}</td>
                          </tr>

                          </tbody>
                        </table>
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div v-else><p>No Customers Added Yet !!</p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
const $ = require('jquery');
window.$ = $;
$(function () {
  $(window)
    .scroll(function () {
      $('nav')
        .toggleClass('scrolled', $(this)
          .scrollTop() > 50);
    });

});
import axios from 'axios';

export default {
  data() {
    return {
      message_en: null,
      message_bn: null,
      user_id: null,
      phone: null,
      message: null,
      response_message: null,
      customers: []
    };
  },
  created: function () {
    if (localStorage.getItem("userinfo")) {
      this.user_id = JSON.parse(localStorage.getItem("userinfo")).id;
    }
    this.deposit_message();
    this.deposit_list();
  },
  methods: {
    addRefererPhone: function () {

      let vm = this;
      if(this.phone){
      let check = this.phone.match(/^(01[3456789])(\d{8})$/);
      if(check == null){
        alert('Phone Number Invalid');
      }else{
        axios.post(this.globalUrl + "add-reference",{
          phone: this.phone,
          user_id: this.user_id
        },)
          .then(function (response) {
            // console.log(response.data);
            vm.response_message = response.data.message;
          })
          .catch((response) => {
            vm.$toasted.show('Something wrong  Try again.', {
              type: 'error',
              icon: 'fa-exclamation-triangle'
            });
          });
      }
      }else{
        vm.$toasted.show('Phone Number can not be empty.', {
          type: 'error',
          icon: 'fa-exclamation-triangle'
        });
      }
    },
    deposit_message: function () {
      let vm = this;
      axios.get(this.globalUrl + "deposit-message")
        .then(function (response) {

          vm.message_en = response.data.data.message_en;
          vm.message_bn = response.data.data.message_bn;

        })
        .catch((response) => {
          //console.log(response);
          vm.$toasted.show('Something wrong  Try again.', {
            type: 'error',
            icon: 'fa-exclamation-triangle'
          });
        });
    },
    deposit_list: function () {
      let vm = this;
      axios.get(this.globalUrl + "deposit-refer-list/"+vm.user_id)
        .then(function (response) {
          vm.customers = response.data.customers;
        })
        .catch((response) => {
          //console.log(response);
          vm.$toasted.show('Something wrong  Try again.', {
            type: 'error',
            icon: 'fa-exclamation-triangle'
          });
        });
    },
  }
};
</script>

